import { WellLogsWidgetWrapper } from '../../well-logs-widget/WellLogsWidget';
import type { WellLogsWidgetEntity } from '../../well-logs-widget/WellLogsWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderWellLogsWidget(widget: WellLogsWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return ({ onCreateWellLogsWidget, onCreateVideobroadcastWidget }) => (
    <WellLogsWidgetWrapper
      entity={widget}
      options={options}
      onCreateWellLogsWidget={onCreateWellLogsWidget}
      onCreateVideobroadcastWidget={onCreateVideobroadcastWidget}
    />
  );
}
